import React, { Component } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  Label,
  Modal,
  Row,
  CardBody,
  ModalHeader,
  ModalBody,
  Spinner,
} from "reactstrap";
import MetaTags from "react-meta-tags";
import API from "../../helpers/api_helper";
import * as Yup from "yup";
import toastr from "toastr";
import Dropzone from "react-dropzone";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";

import { Formik, Field, Form, ErrorMessage } from "formik";
import BootstrapTable from "react-bootstrap-table-next";
import { Constants } from "helpers/constants";
import { Link } from "react-router-dom";

class AboutUsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      users: [],
      loading: true,
      subLoading: false,
      modal: false,
      formValue: {
        description: "",
      },
      isEdit: true,
      selectedUser: null,
      selectedFiles: [],
    };
  }
  componentDidMount() {
    this.didMount();
  }

  didMount = async () => {
    this.setState({ loading: true });
    try {
      const res = await API.aboutUs.list();
      console.log("RES IS : ", res);
      if (res.status) {
        this.setState({
          loading: false,
          users: res.data,
        });
      } else {
        throw res;
      }
    } catch (error) {
      console.log("ERROR CODE 3 : ", error);
    }
  };

  toggle = () => {
    this.setState(prevState => ({
      modal: !prevState.modal,
    }));
  };

  handleSubmitAddForm = async values => {
    const { selectedUser, isEdit } = this.state;

    this.setState({ subLoading: true });

    const formData = new FormData();

    formData.append("description", values.description);
    if (!!this.state.selectedFiles.length) {
      formData.append(
        "image",
        this.state.selectedFiles[0],
        this.state.selectedFiles[0].name
      );
    }

    if (isEdit) {
      formData.append("about_id", selectedUser.id);
      try {
        const res = await API.aboutUs.edit(formData);
        if (res.status) {
          toastr.success("درباره با موفقیت ویرایش شد", "موفق");
          this.setState({
            subLoading: false,
            modal: false,
            isEdit: false,
            selectedUser: null,
          });
          this.didMount();
        } else {
          throw res;
        }
      } catch (error) {
        this.setState({ subLoading: false });
        console.log("ERROR CODE 5 : ", error);
      }
    } else {
      console.log("IS NEW FIRE");
      try {
        const res = await API.aboutUs.add(formData);
        console.log("RES IS : ", res);
        if (res.status) {
          toastr.success(res.message, "موفق");
          this.setState({ subLoading: false, modal: false });
          this.didMount();
        } else {
          throw res;
        }
      } catch (error) {
        this.setState({ subLoading: false });
        console.log("ERROR CODE 4 : ", error);
      }
    }
  };

  handleUserClick = arg => {
    const { description } = arg;
    console.log("ARG : ", arg);

    this.setState({
      formValue: {
        description,
      },
      isEdit: true,
      selectedUser: arg,
    });

    this.toggle();
  };

  handleAcceptedFiles = files => {
    files.map(file =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: this.formatBytes(file.size),
      })
    );

    this.setState({ selectedFiles: files });
  };

  handleAcceptedVidFiles = files => {
    files.map(file =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: this.formatBytes(file.size),
      })
    );

    this.setState({ selectedVidFiles: files });
  };

  formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  };

  render() {
    const { SearchBar } = Search;
    const { users, loading, modal, isEdit, subLoading, formValue } = this.state;

    const pageOptions = {
      sizePerPage: 10,
      totalSize: users.length, // replace later with size(users),
      custom: true,
    };

    const defaultSorted = [
      {
        dataField: "id", // if dataField is not match to any column you defined, it will be ignored.
        order: "desc", // desc or asc
      },
    ];

    const selectRow = {
      mode: "checkbox",
    };

    const columns = [
      {
        text: "id",
        dataField: "id",
        sort: true,
        hidden: true,
        formatter: (cellContent, user) => <>{user.id}</>,
      },
      {
        dataField: "image",
        text: "تصویر",
        sort: true,
        formatter: (cellContent, user) => (
          <img
            src={Constants.imageUrl + user.image}
            width={50}
            alt="icon"
            className="rounded me-2 onHoverBig"
          />
        ),
      },
      {
        dataField: "description",
        text: "توضیحات",
        sort: true,
        formatter: val => <p style={{ whiteSpace: "break-spaces" }}>{val}</p>,
      },
      {
        dataField: "menu",
        isDummyField: true,
        editable: false,
        text: "Action",
        formatter: (cellContent, user) => (
          <div className="d-flex gap-3">
            <Link className="text-success" to="#">
              <i
                className="mdi mdi-pencil font-size-18"
                id="edittooltip"
                onClick={() => this.handleUserClick(user)}
              ></i>
            </Link>
          </div>
        ),
      },
    ];

    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>خانه من | مدیریت درباره ما</title>
          </MetaTags>
          <Container fluid>
            <Breadcrumbs title="خانه من" breadcrumbItem="مدیریت درباره ما" />
          </Container>

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  {loading ? (
                    <Spinner size="lg" />
                  ) : (
                    <PaginationProvider
                      pagination={paginationFactory(pageOptions)}
                      keyField="id"
                      columns={columns}
                      data={users}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField="id"
                          columns={columns}
                          data={users}
                          search
                        >
                          {toolkitprops => (
                            <React.Fragment>
                              <Row className="mb-2">
                                <Col sm="4">
                                  <div className="search-box ms-2 mb-2 d-inline-block">
                                    <div className="position-relative">
                                      <SearchBar
                                        {...toolkitprops.searchProps}
                                        placeholder="جستجو"
                                      />
                                      <i className="bx bx-search-alt search-icon" />
                                    </div>
                                  </div>
                                </Col>
                                <Col sm="8">
                                  {/* <div className="text-sm-end">
                                    <Button
                                      color="primary"
                                      className="font-16 btn-block btn btn-primary bg-gold"
                                      onClick={this.toggle}
                                    >
                                      <i className="mdi mdi-plus-circle-outline me-1" />
                                      ایجاد درباره جدید
                                    </Button>
                                  </div> */}
                                </Col>
                              </Row>
                              <Row>
                                <Col xl="12">
                                  <div className="table-responsive">
                                    <BootstrapTable
                                      {...toolkitprops.baseProps}
                                      {...paginationTableProps}
                                      selectRow={selectRow}
                                      defaultSorted={defaultSorted}
                                      classes={
                                        "table align-middle table-nowrap table-hover"
                                      }
                                      bordered={false}
                                      striped={false}
                                      responsive
                                      ref={this.node}
                                    />

                                    <Modal
                                      isOpen={modal}
                                      onClosed={() =>
                                        this.setState({
                                          formValue: {
                                            description: "",
                                          },
                                        })
                                      }
                                    >
                                      <ModalHeader
                                        toggle={this.toggle}
                                        tag="h4"
                                      >
                                        {!!isEdit
                                          ? "ویرایش درباره"
                                          : "اضافه کردن درباره"}
                                      </ModalHeader>
                                      <ModalBody>
                                        <Formik
                                          enableReinitialize={true}
                                          initialValues={formValue}
                                          validationSchema={Yup.object().shape({
                                            description:
                                              Yup.string().required("اجباری"),
                                          })}
                                          onSubmit={this.handleSubmitAddForm}
                                        >
                                          {({ errors, status, touched }) => (
                                            <Form>
                                              <Row>
                                                <Col xs={12}>
                                                  <Dropzone
                                                    onDrop={acceptedFiles =>
                                                      this.handleAcceptedFiles(
                                                        acceptedFiles
                                                      )
                                                    }
                                                    multiple={false}
                                                  >
                                                    {({
                                                      getRootProps,
                                                      getInputProps,
                                                    }) => (
                                                      <div className="dropzone">
                                                        <div
                                                          className="dz-message needsclick"
                                                          {...getRootProps()}
                                                        >
                                                          <input
                                                            {...getInputProps()}
                                                          />
                                                          <div className="mb-3">
                                                            <i className="display-4 text-muted bx bxs-cloud-upload" />
                                                          </div>
                                                          <h4>
                                                            برای انتخاب عکس کلیک
                                                            کنید یا بکشید
                                                          </h4>
                                                        </div>
                                                      </div>
                                                    )}
                                                  </Dropzone>
                                                  <div
                                                    className="dropzone-previews mt-3"
                                                    id="file-previews"
                                                  >
                                                    {this.state.selectedFiles.map(
                                                      (f, i) => {
                                                        return (
                                                          <Card
                                                            className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                                            key={i + "-file"}
                                                          >
                                                            <div className="p-2">
                                                              <Row className="align-items-center">
                                                                <Col className="col-auto">
                                                                  <img
                                                                    data-dz-thumbnail=""
                                                                    height="80"
                                                                    className="avatar-sm rounded bg-light"
                                                                    alt={f.name}
                                                                    src={
                                                                      f.preview
                                                                    }
                                                                  />
                                                                </Col>
                                                                <Col>
                                                                  <Link
                                                                    to="#"
                                                                    className="text-muted font-weight-bold"
                                                                  >
                                                                    {f.name}
                                                                  </Link>
                                                                  <p className="mb-0">
                                                                    <strong>
                                                                      {
                                                                        f.formattedSize
                                                                      }
                                                                    </strong>
                                                                  </p>
                                                                </Col>
                                                              </Row>
                                                            </div>
                                                          </Card>
                                                        );
                                                      }
                                                    )}
                                                  </div>
                                                </Col>

                                                <Col className="col-12">
                                                  <div className="mb-3">
                                                    <Label className="form-label">
                                                      توضیحات
                                                    </Label>
                                                    <Field
                                                      name="description"
                                                      type="text"
                                                      as="textarea"
                                                      rows={5}
                                                      className={
                                                        "form-control" +
                                                        (errors.description &&
                                                        touched.description
                                                          ? " is-invalid"
                                                          : "")
                                                      }
                                                    />
                                                    <ErrorMessage
                                                      name="description"
                                                      component="div"
                                                      className="invalid-feedback"
                                                    />
                                                  </div>
                                                </Col>
                                              </Row>
                                              <Row>
                                                <Col>
                                                  {subLoading ? (
                                                    <div className="text-end">
                                                      <button
                                                        type="button"
                                                        className="btn btn-success save-user bg-gold"
                                                        style={{
                                                          minWidth: "100px",
                                                        }}
                                                      >
                                                        <i className="bx bx-loader bx-spin font-size-16 align-middle" />{" "}
                                                        Loading
                                                      </button>
                                                    </div>
                                                  ) : (
                                                    <div className="text-end">
                                                      <button
                                                        type="submit"
                                                        className="btn btn-success save-user bg-gold"
                                                        style={{
                                                          minWidth: "100px",
                                                        }}
                                                      >
                                                        Save
                                                      </button>
                                                    </div>
                                                  )}
                                                </Col>
                                              </Row>
                                            </Form>
                                          )}
                                        </Formik>
                                      </ModalBody>
                                    </Modal>
                                  </div>
                                </Col>
                              </Row>
                              <Row className="align-items-md-center mt-30">
                                <Col className="pagination pagination-rounded justify-content-end mb-2">
                                  <PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </Col>
                              </Row>
                            </React.Fragment>
                          )}
                        </ToolkitProvider>
                      )}
                    </PaginationProvider>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </React.Fragment>
    );
  }
}

export default AboutUsPage;
